/**
 * Organização ativa (header X-Org-Id). Sem valor salvo, o servidor usa a
 * primeira organização do usuário. Preparado para o seletor de organizações.
 */
const KEY = "tenanci.orgId";

export function getOrgId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setOrgId(orgId: string | null) {
  try {
    if (orgId) localStorage.setItem(KEY, orgId);
    else localStorage.removeItem(KEY);
  } catch {
    /* ignora */
  }
}
